import mapLD from "lodash-es/map";
import splitLD from "lodash-es/split";
import snakeCaseLD from "lodash-es/snakeCase";
import { AppStateConstant } from "../constants/AppState.constant";
import { Router } from "@angular/router";
import { MOMENT_DATE_FORMAT } from "../config/MomentDateFormat.config";
import moment from "moment";
import { Buffer } from "buffer";
import { isEmpty } from "lodash-es";
import { v4 as uuidv4 } from "uuid";
import { APP_CONFIG } from "app.config";
import {
  BehaviorSubject,
  distinctUntilChanged,
  startWith,
  Subject,
  takeUntil,
  tap,
} from "rxjs";
import { FormControl, FormGroup } from "@angular/forms";
import { XAdvancedFilterControl } from "app/shared/components/x-advanced-filter/x-advanced-filter.model";
import { ICommonDataSource } from "app/shared/components/candidate/model/type";
import { CandidateStatusEnum } from "app/shared/components/candidate/model/enum";
import { ONLINE_CANDIDATE_RESUME_STATUS } from "app/modules/manage/workflow/task/workflow-task.constant";
import { toHTML } from "ngx-editor";
import DOMPurify from "dompurify";

export class UtilCommon {
  constructor() { }

  static isPhoneNumber(number) {
    if (!number) {
      return false;
    }
    if (number.toString()[0] !== "0") {
      return false;
    }
    if (number.toString().length !== 10 && number.toString().length !== 11) {
      return false;
    }
    if (!UtilCommon.isNumber(number)) {
      return false;
    }
    return true;
    // return /([\+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/.test(number);
  }

  static getAppState(): any {
    return window[AppStateConstant.appState] ?? "";
  }

  static generateUUID(): string {
    try {
      let d: number = new Date().getTime();
      const uuid: any = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c: any): string {
          let r: any = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    } catch (e) { }
  }

  static avoidEventBubble(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  static formatDate(
    value: any,
    format: string = MOMENT_DATE_FORMAT.ONLY_DATE
  ): string {
    let language: any = "vi"; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
    if (language === "vi" && format === MOMENT_DATE_FORMAT.ONLY_DATE) {
      format = MOMENT_DATE_FORMAT.ONLY_DATE_VN;
    }
    if (value && (typeof value === "number" || typeof value === "string")) {
      const d: Date = new Date(value);
      const m: moment.Moment = moment(d);
      return m.format(format);
    } else if (value && value instanceof Date) {
      const m: moment.Moment = moment(value);
      return m.format(format);
    }
    return "";
  }

  static formatDateFullTime(
    value: any,
    format: string = MOMENT_DATE_FORMAT.FULL_TIME
  ): string {
    let language: any = "vi"; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
    if (language === "vi") {
      format = MOMENT_DATE_FORMAT.FULL_TIME_VN;
    }
    if (value && (typeof value === "number" || typeof value === "string")) {
      const d: Date = new Date(value);
      const m: moment.Moment = moment(d);
      return m.format(format);
    } else if (value && value instanceof Date) {
      const m: moment.Moment = moment(value);
      return m.format(format);
    }
    return "";
  }

  static formatDateTimeWithoutSecond(
    value: any,
    format: string = MOMENT_DATE_FORMAT.FULL_TIME_WITHOUT_SECOND
  ): string {
    let language: any = "vi"; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
    if (language === "vi") {
      format = MOMENT_DATE_FORMAT.FULL_TIME_WITHOUT_SECOND_VN;
    }
    if (value && (typeof value === "number" || typeof value === "string")) {
      const d: Date = new Date(value);
      const m: moment.Moment = moment(d);
      return m.format(format);
    } else if (value && value instanceof Date) {
      const m: moment.Moment = moment(value);
      return m.format(format);
    }
    return "";
  }

  static formatDateTimeWithoutSecond12H(
    value: any,
    format: string = MOMENT_DATE_FORMAT.FULL_TIME_WITHOUT_SECOND_12H
  ): string {
    let language: any = "vi"; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
    if (language === "vi") {
      format = MOMENT_DATE_FORMAT.FULL_TIME_WITHOUT_SECOND_12H_VN;
    }
    if (value && (typeof value === "number" || typeof value === "string")) {
      const d: Date = new Date(value);
      const m: moment.Moment = moment(d);
      return m.format(format);
    } else if (value && value instanceof Date) {
      const m: moment.Moment = moment(value);
      return m.format(format);
    }
    return "";
  }

  static formatTimeToHHMMSS(timeString: string): string {
    if (!timeString) return '';
    const date = new Date(`1970-01-01T${timeString}`);
    // This will output in local time, if you want UTC use date.toISOString().substr(11, 8)
    return date.toISOString().substr(11, 8); // "hh:mm:ss"
  }

  static formatDateJsonSchemaForm(value: any): string {
    if (value && (typeof value === "number" || typeof value === "string")) {
      value = new Date(value);
      const date =
        value.getDate() > 9 ? value.getDate() : "0" + value.getDate();
      const month =
        value.getMonth() + 1 > 9
          ? value.getMonth() + 1
          : "0" + (value.getMonth() + 1);
      return `${value.getFullYear()}-${month}-${date}`;
    } else if (value && value instanceof Date) {
      const date =
        value.getDate() > 9 ? value.getDate() : "0" + value.getDate();
      const month =
        value.getMonth() + 1 > 9
          ? value.getMonth() + 1
          : "0" + (value.getMonth() + 1);
      return `${value.getFullYear()}-${month}-${date}`;
    }
  }

  static formatPhoneNumber(phone) {
    if (!phone) {
      return "";
    }
    const countryCode = "+84";
    const countryCodeExt = "(+84)";

    // Check if the phone number starts with the country code
    if (phone.startsWith(countryCode) || phone.startsWith(countryCodeExt)) {
      // Split the phone number and remove the leading zero
      const parts = phone.split(" ");
      if (parts.length < 2) {
        return phone; // Return original if format is unexpected
      }
      const mobile = parts[1];
      return `${countryCode} ${mobile.startsWith("0") ? mobile.substring(1) : mobile}`;
    } else if (phone.startsWith("0")) {
      // If the phone number starts with 0, remove it and prepend the country code
      return `${countryCode} ${phone.substring(1)}`;
    }

    // Return the original phone number if no changes are needed
    return phone;
  }

  static formatPhoneForFts(phone) {
    if (phone) {
      const parts = phone.split(" ");
      const mobile = parts[1];
      return ' 0' + mobile;
    }
    return ''
  }

  static getLinkDashboard(
    sanitizer: any,
    isToolbar: boolean,
    permissions: any
  ): any {
    const versionDashboard =
      window["MULTIPLE_APP"]["dashboard"] || new Date().getTime();
    let toolbar = "?v=" + versionDashboard;
    if (isToolbar) {
      toolbar += "&toolbar=true";
    }
    sessionStorage.setItem("permissionsDashboard", JSON.stringify(permissions));
    // toolbar += '&permission=' + JSON.stringify(permissions);
    if (
      location.href.indexOf("gateway-dev") > -1 ||
      location.href.indexOf("localhost") > -1
    ) {
      return sanitizer.bypassSecurityTrustResourceUrl(
        window["HOSTNAME_DASHBOARD"]
      );
    } else {
      return sanitizer.bypassSecurityTrustResourceUrl(
        window["HOSTNAME_DASHBOARD"]
      );
    }
  }

  static formatDatePeriod(value: any): string {
    if (value && (typeof value === "number" || typeof value === "string")) {
      value = new Date(value);
      const month =
        value.getMonth() + 1 > 9
          ? value.getMonth() + 1
          : "0" + (value.getMonth() + 1);
      return `${month}/${value.getFullYear()}`;
    } else if (value && value instanceof Date) {
      const date =
        value.getDate() > 9 ? value.getDate() : "0" + value.getDate();
      const month =
        value.getMonth() + 1 > 9
          ? value.getMonth() + 1
          : "0" + (value.getMonth() + 1);
      return `${month}/${value.getFullYear()}`;
    }
  }

  static loadCSS(cssId: any, csstUrl: any): Promise<any> {
    return new Promise((resolve: any, reject: any) => {
      if (!document.getElementById(cssId)) {
        const head: any = document.getElementsByTagName("head")[0];
        const link: any = document.createElement("link");
        link.id = cssId;
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = csstUrl;
        link.media = "all";
        link.onload = function (): void {
          resolve(true);
        };
        link.onerror = function (): void {
          resolve(undefined);
        };
        head.appendChild(link);
      } else {
        resolve(true);
      }
    });
  }

  static async loadScriptAsync(objScript: any, scriptUrl: any) {
    return new Promise((resolve, reject) => {
      const me: any = this;

      if (objScript) {
        resolve(me);
        return;
      }

      const script: any = document.createElement("script");
      script.type = "text/javascript";
      script.src = scriptUrl;
      script.async = false;
      if (script.readyState) {
        // IE
        script.onreadystatechange = function (): void {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = undefined;
            resolve(me);
          }
        };
      } else {
        // Others
        script.onload = function (): void {
          resolve(me);
        };
      }
      document.head.appendChild(script);
    });
  }

  static loadScript(
    objScript: any,
    scriptUrl: any,
    callback: any,
    typeAsync: boolean = false
  ): void {
    const me: any = this;

    if (objScript) {
      callback(me);
      return;
    }

    const script: any = document.createElement("script");
    script.type = "text/javascript";
    script.src = scriptUrl;
    script.async = typeAsync;
    if (script.readyState) {
      // IE
      script.onreadystatechange = function (): void {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = undefined;
          callback(me);
        }
      };
    } else {
      // Others
      script.onload = function (): void {
        callback(me);
      };
    }
    document.head.appendChild(script);
  }

  static remove_unicode(str: string): string {
    if (!str) {
      return str;
    }
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ầ|Ẩ|Ậ|Ă|Ằ|Ấ|Ă|Ẳ|Ẵ/g, "A");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ẽ|Ể|Ễ/g, "E");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ổ|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ|Ố/g, "O");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/Ỷ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/Đ/g, "D");
    return str;
  }

  static getFilterModelSorts(filterModel: any, filter: string = ``): string {
    let filterString: string = filter;
    filterString = "";
    if (this.objectIsEmpty(filterModel)) {
      return "";
    }
    const keys: any = Object.keys(filterModel);
    keys.forEach((key: any) => {
      if (filterModel[key] !== null) {
        if (filterString.length === 0) {
          filterString = `{"field":"${key}","direction":"${filterModel[key]}"}`;
        } else {
          filterString += `,{"field":"${key}","direction":"${filterModel[key]}"}`;
        }
      }
    });
    return filterString;
  }

  static splitCharacterSpace(str: string): string {
    if (!str) {
      return "";
    }
    return str.replace(/\s/g, "");
  }

  static isArray(array: any, checkLength: boolean = true, isSort: boolean = true): boolean {
    if (!array) {
      return false;
    }
    if (checkLength) {
      if (Array.isArray(array) && array.length > 0) {
        if (isSort) {
          UtilCommon.sortArray(array);
        }
        return true;
      }
    } else if (Array.isArray(array)) {
      if (isSort) {
        UtilCommon.sortArray(array);
      }
      return true;
    }

    return false;
  }

  static sortArray(array): void {
    if (!array && !Array.isArray(array)) {
      return;
    }
    array.sort((a, b) => {
      const nameA = UtilCommon.getLabelLanguage(a?.email || a?.employeeEmail || a?.interviewerEmail || a?.name || a?.code) || "";
      const nameB = UtilCommon.getLabelLanguage(b?.email || b?.employeeEmail || b?.interviewerEmail || b?.name || b?.code) || "";
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
    });
  }

  // get data header from server
  static getTokenFromLogin(resHeaders: any): void {
    if (resHeaders) {
      resHeaders.forEach((data: any, key: any) => {
        if (key.toString().toUpperCase() === "X-AUTH-TOKEN") {
          window["X-AUTH-TOKEN"] = data;
          localStorage.setItem("X-AUTH-TOKEN", data);
        } else if (key.toString().toUpperCase() === "X-AUTH-MESSAGE") {
          window["X-AUTH-MESSAGE"] = decodeURIComponent(data);
        }
      });
    }
  }

  static getToken(): string {
    return localStorage.getItem("tokenJWT") || "";
  }

  static handleUrl(href: string): string {
    let handleUrl: any = "",
      link: any;
    if (href.indexOf("#") > -1) {
      link = href.split("#");
      handleUrl = link[1].toString();
    }
    return handleUrl;
  }

  static handleDataSubmitServer(dataHandle: any): any {
    if (dataHandle.code === -1) {
      return -1;
    }
    return dataHandle.code;
  }

  static objectIsEmpty(map: any): boolean {
    for (const key in map) {
      if (map.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  static validateSlugNotRequired(slug: string): boolean {
    // Only allow lowercase a-z and hyphens
    if (slug == "" || slug == null) return true;

    const regex = /^[a-z0-9-]+$/;
    return regex.test(slug);
  }

  static validateEmail(email: string): boolean {
    // const regex: any = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    const regex: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  static validatePassword(password: string): boolean {
    const regex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#+=_()<>?.,$%^&*])(?=.{8,})"
    );
    return regex.test(password);
  }

  static validateAccessCode(password: string): boolean {
    const regex = new RegExp(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/g
    );
    return regex.test(password);
  }

  static validateLink(link: string): boolean {
    if (!link || link.trim() === "") {
      return false;
    }

    // Must contain at least one dot
    if (!link.includes('.')) {
      return false;
    }

    // Basic URL pattern validation with required dot
    const urlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(:\d+)?(\/.*)?$/i;
    return urlRegex.test(link);
  }

  static isNumber(value: any): boolean {
    // return !isNaN(str);
    // return typeof str === 'number';
    // if (typeof value != "string") return false;
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  static convertDateToIsoString(date: number): string {
    if (!date) {
      return new Date().toISOString();
    }
    return new Date(date).toISOString();
  }

  static isDate(value: any): boolean {
    const date = new Date(value);
    return date instanceof Date && !isNaN(date as any);
  }

  static isValidDate(date: any): boolean {
    return !isNaN(date);
  }

  static async convertMenuTree(dataMenu: any) {
    const menuParent: any = [
      {
        id: "1",
        translate: "NAV.APPLICATIONS",
        type: "group",
        children: [],
      },
    ];
    // let lastIndex = 0;
    let language: any =
      localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE;
    let url =
      "assets/i18n/menu/" +
      this.buildUrlLoadMenu() +
      "/" +
      language +
      ".js?v=" +
      new Date().getTime();
    await this.loadScriptAsync(
      window["language_" + language],
      "assets/i18n/menu/" +
      this.buildUrlLoadMenu() +
      "/" +
      language +
      ".js?v=" +
      new Date().getTime()
    );
    language = window["language_" + language];
    const languageNAV = language.data.NAV;
    const menuFinal = [];
    for (const menu of dataMenu) {
      if (menu.menuName) {
        menu.title = languageNAV[menu.menuCode];
      }
      menu.id = menu.id.toString();
      menu.icon = "dashboard";
      const children: any[] = menu.children;
      if (this.isArray(children)) {
        menu.type = "collapsable";
        let child = null;
        for (let index = 0; index < children.length; index++) {
          child = children[index];
          let childrenLv2 = null;
          for (let childT of children[index].children) {
            childT = this.defineMenuChild(childT, languageNAV);
            childrenLv2 = childT.children;
            for (let childT2 of childrenLv2) {
              childT2 = this.defineMenuChild(childT2, languageNAV);
            }
          }
          children[index] = {
            title: languageNAV[child.menuCode],
            id: child.id.toString(),
            type: "collapsable",
            icon: this.getMenuIcon(children[index].menuCode),
            children: children[index].children,
            menuCode: children[index].menuCode,
          };
        }
      } else {
        menu.type = "basic";
        menu.link = menu.historyToken;
        menu.menuCode = menu.menuCode;
        menu.title = languageNAV[menu.menuCode];
      }
      menuFinal.push({
        id: menu.menuCode,
        title: languageNAV[menu.menuCode],
        type: "group",
        icon: "apps",
        children: menu.children,
        menuCode: menu.menuCode,
      });
    }
    menuParent[0].children = dataMenu;
    sessionStorage.setItem("menuFinal", JSON.stringify(menuFinal));
    localStorage.setItem("menuFinal", JSON.stringify(menuFinal));
    return menuFinal;
  }

  static async convertMenuTreeCompact(dataMenu: any) {

    // let lastIndex = 0;
    let language: any =
      localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE;
    await this.loadScriptAsync(
      window["language_" + language],
      "assets/i18n/menu/" +
      this.buildUrlLoadMenu() +
      "/" +
      language +
      ".js?v=" +
      new Date().getTime()
    );
    language = window["language_" + language];
    const languageNAV = language.data.NAV;
    const menuFinal = [];

    for (const menu of dataMenu) {
      const children: any[] = [];
      if (this.isArray(menu.children)) {
        for (let child of menu.children) {
          if (this.isArray(child.children)) {
            const childF2 = [];
            for (let childF3 of child.children) {
              childF2.push({
                id: childF3.menuCode,
                title: "MENU." + languageNAV[childF3.menuCode],
                type: "basic",
                link: UtilCommon.handleHistoryToken(childF3.historyToken),
              });
            }
            children.push({
              id: child.menuCode,
              title: "MENU." + languageNAV[child.menuCode],
              type: "collapsable",
              icon: this.getMenuIcon(child.menuCode),
              children: childF2,
            });
          } else {
            children.push({
              id: child.menuCode,
              title: "MENU." + languageNAV[child.menuCode],
              type: "basic",
              icon: this.getMenuIcon(child.menuCode),
              link: UtilCommon.handleHistoryToken(child.historyToken),
            });
          }
        }
      }
      menuFinal.push({
        id: menu.menuCode,
        title: "MENU." + languageNAV[menu.menuCode],
        // tooltip: 'MENU.' + languageNAV[menu.menuCode],
        type: "group",
        icon: this.getMenuIcon(menu.menuCode),
        children: children,
      });
    }
    sessionStorage.setItem("menuFinal", JSON.stringify(menuFinal));
    localStorage.setItem("menuFinal", JSON.stringify(menuFinal));
    return menuFinal.flatMap(item => item.children?.map(child => ({
      ...child,
      children: child.children || []
    })) || []);
  }

  static getMenuIcon(menuCode) {
    switch (menuCode) {
      case "APPLICATION.1":
        return "heroicons_outline:user-circle";
      case "APPLICATION.2":
        return "heroicons_outline:cog";
      // case 'APPLICATION.3': return 'heroicons_outline:document';
      // case 'APPLICATION.4': return 'heroicons_outline:';
      case "APPLICATION.5":
        return "heroicons_outline:identification";
      case 'APPLICATION.1.2': return 'heroicons_outline:menu-request';
      case 'APPLICATION.1.3': return 'heroicons_outline:menu-candidates';
      case 'APPLICATION.1.4': return 'heroicons_outline:menu-programs';
      case 'APPLICATION.1.5': return 'heroicons_outline:menu-survey';
      case 'APPLICATION.1.6': return 'heroicons_outline:menu-erp';
      case 'APPLICATION.1.7': return 'heroicons_outline:menu-career-site';
      case 'APPLICATION.1.8': return 'heroicons_outline:menu-dashboard';
      case 'APPLICATION.1.9': return 'heroicons_outline:menu-setting';
      // case 'APPLICATION.2.1': return 'description';
      // case 'APPLICATION.2.2': return 'share';
      // case 'APPLICATION.3.1': return 'dashboard';
      // case 'APPLICATION.3.2': return 'person';
      // case 'APPLICATION.3.3': return 'settings_suggest';
      // case 'APPLICATION.4.1': return 'article';
      // case 'APPLICATION.5.1': return 'person';
      // case 'APPLICATION.5.3': return 'notifications';
      // case 'APPLICATION.5.4': return 'file_copy';
      // case 'APPLICATION.5.2': return 'draw';
      // case 'APPLICATION.5.5': return 'password';
      case 'APPLICATION.5.1.1': return 'heroicons_outline:menu-setting';


    }
    return "heroicons_outline:folder";
  }

  static async convertLanguageMenu(dataMenu: any) {
    let language: any =
      localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE;
    const url =
      "assets/i18n/menu/" +
      this.buildUrlLoadMenu() +
      "/" +
      language +
      ".js?v=" +
      new Date().getTime();
    await this.loadScriptAsync(
      window["language_" + language],
      "assets/i18n/menu/" +
      this.buildUrlLoadMenu() +
      "/" +
      language +
      ".js?v=" +
      new Date().getTime()
    );
    language = window["language_" + language];
    const languageNAV = language.data.NAV;
    for (const menu of dataMenu) {
      // menu.title = languageNAV[menu.menuCode];
      menu.title = "MENU." + menu.title;
      const children = menu.children;
      for (const child of children) {
        // child.title = languageNAV[child.menuCode];
        child.title = "MENU." + child.title;
        for (const c of child.children) {
          c.title = "MENU." + c.title;
          // c.title = languageNAV[c.menuCode];
        }
      }
    }
    sessionStorage.setItem("menuFinal", JSON.stringify(dataMenu));
    localStorage.setItem("menuFinal", JSON.stringify(language));
    return dataMenu;
  }

  static buildUrlLoadMenu(): string {
    const appState = (<any>window)[AppStateConstant.appState];
    if (appState) {
      if (appState.moreInfo) {
        return "default";
      }
    }
    return "default";
  }

  private static defineMenuChild(childT: any, languageNAV: any): any {
    let link: string = "";
    link = UtilCommon.handleHistoryToken(childT.historyToken);
    if (!link) {
      link = childT.historyToken;
    }
    if (this.isArray(childT.children)) {
      childT.type = "collapsable";
    } else {
      childT.type = "basic";
      childT.link = link;
      childT.exactMatch = true;
    }
    childT.title = languageNAV[childT.menuCode];
    // childT.title = 'MENU.'+ childT.menuName;
    childT.menuCode = childT.menuCode;
    return childT;
  }

  public static handleHistoryToken(historyToken) {
    let link = "home";
    switch (historyToken) {
      case "rrm-profile":
        link = "settings/profile";
        break;
      case "rrm-process-list":
        link = "manage/process";
        break;
      case "rrm-my-task":
        link = "manage/my-task";
        break;
      case "rrm-my-request":
        link = "manage/my-request";
        break;
      case "rrm-my-draft":
        link = "manage/my-draft";
        break;
      case "rrm-my-watch":
        link = "manage/my-watch";
        break;
      case "rrm-my-approvals":
        link = "manage/my-approvals";
        break;
      case "rrm-all-request":
        link = "manage/all-request";
        break;
      case "rrm-task":
        link = "manage/request-task";
        break;
      case "rrm-tracking":
        link = "manage/request-tracking";
        break;
      case "rrm-my-post":
        link = "manage/job-posting";
        break;
      case "rrm-candidate":
        link = "manage/recruitment-candidate";
        break;
      case "rrm-candidate-group":
        link = "manage/duplicate-candidates";
        break;
      case "rrm-online-candidate":
        link = "manage/talent-pool-applicants";
        break;
      case "rrm-online-candidate-pin":
        link = "manage/online-candidate-pin-list";
        break;
      case "rrm-candidate-pin":
        link = "manage/candidate-pin-list";
        break;
      case "rrm-ex-employee":
        link = "manage/former-employee";
        break;
      case "rrm-program-event":
        link = "manage/events";
        break;
      case "rrm-student":
        link = "manage/student-program-applicants";
        break;
      case "rrm-recruitment-staff":
        break;
      case "rrm-create-request":
        link = "manage/request/create";
        break;
      case "rrm-survey-response":
        link = "manage/survey-results";
        break;
      case "rrm-dashboard":
        link = "report/dashboards-boldbi";
        break;
      case "rrm-dashboard-design":
        link = "report/dashboards-design";
        break;
      case "rrm-report":
        link = "report/reports-boldbi";
        break;
      case "rrm-download-report":
        link = "report/download-report";
        break;
      case "rrm-download-export":
        link = "report/download-export";
        break;
      case "rrm-erp-paymentline":
        link = "manage/eligible-erp-list";
        break;
      case "rrm-erp-paymenttime":
        link = "manage/erp-payment";
        break;
      case "rrm-cs-user-register":
        link = "manage/registered-user";
        break;
      case "rrm-erp-config":
        link = "manage/erp-config";
        break;
      case "rrm-erp-exclusion":
        link = "manage/erp-exclusion";
        break;
      case "rrm-erp-payment":
        link = "manage/erp-payment-config";
        break;
      case "rrm-program-field":
        link = "manage/fields";
        break;
      case "rrm-program-question":
        link = "manage/program-questionnaires";
        break;
      case "rrm-program-gifts":
        link = "manage/rewards";
        break;
      case "rrm-questionnaire-survey":
        link = "manage/questionnaire-list";
        break;
      case "rrm-question-survey":
        link = "manage/create-questionnaire";
        break;
      case "rrm-candidate-pin":
        link = "manage/candidate-rr-pin";
        break;
      case "rrm-saved-candidate":
        link = "manage/my-talent-pool";
        break;
      case "rrm-online-candidate-pin":
        link = "manage/online-candidate-pin";
        break;
      case "rrm-recommender-cv":
        link = "manage/erp-candidates";
        break;
      case "rrm-student-checkin":
        link = "manage/attendees";
        break;
      case "rrm-key-student":
        link = "manage/key-student";
        break;
      case "rrm-custom-report":
        link = "report/custom-reports";
        break;
      default:
    }
    return link;
  }

  static readBlobAsText(blob: Blob): Promise<string> {
    if (!blob) {
      return Promise.resolve("");
    }
    return new Promise((resolve, reject) => {
      const reader: any = new FileReader();
      reader.addEventListener("loadend", () => {
        resolve(reader.result);
      });
      reader.addEventListener("error", (e) => {
        reader.abort();
        reject(e);
      });
      reader.readAsText(blob);
    });
  }

  static downloadFile(fileName: string, blob: Blob): void {
    if (blob) {
      const anchorElement = document.createElement("a");
      anchorElement.download = fileName;
      anchorElement.href = window.URL.createObjectURL(blob);
      anchorElement.click();
    }
  }

  static isString(str: any): boolean {
    return typeof str === "string" || str instanceof String;
  }

  static toSnakeCase(str: string, separator = "."): string {
    return mapLD(splitLD(str, separator), snakeCaseLD).join(separator);
  }

  static encodeUriEachField(dataObj: any): string {
    let filterString = "";
    if (this.objectIsEmpty(dataObj)) {
      return filterString;
    }
    const keys: any = Object.keys(dataObj);
    let encodeText = "";
    keys.forEach((key: any) => {
      if (dataObj[key] !== null) {
        encodeText = encodeURI(dataObj[key]);
        filterString += `${key}=${encodeText}&`;
      }
    });
    if (filterString.lastIndexOf("&") > -1) {
      filterString = filterString.slice(0, -1);
    }
    return filterString;
  }

  static checkUsernameValid(): boolean {
    if (!window[AppStateConstant.appState]) {
      return true;
    }
    const username: string = localStorage.getItem(AppStateConstant.userName);
    const usernameTemp: string = (window[AppStateConstant.appState] as any)
      .username;
    if (!username || !usernameTemp) {
      return true;
    }
    if (
      username.toLowerCase().toString() !==
      usernameTemp.toLowerCase().toString()
    ) {
      return false;
    }
    return true;
  }

  static isNotNull(data): boolean {
    if (data == null || data === undefined) {
      return false;
    }
    if (data === "") {
      return false;
    }
    return true;
  }

  static checkDataFromServeComplete(data): boolean {
    if (data == null || data === undefined) {
      return false;
    }
    if (data === "") {
      return false;
    }
    return true;
  }

  static routingPageChildWithQueryparams(
    url: string,
    router: Router,
    data: string,
    queryParams: any = {}
  ): void {
    router.navigate([url, data], { queryParams });
  }

  static routingPageChild(
    url: string,
    activatedRoute: any = null,
    router: Router,
    ...data: any[]
  ): void {
    if (activatedRoute) {
      router.navigate([url, ...data], { relativeTo: activatedRoute });
    } else {
      router.navigate([url, ...data]);
    }
  }

  static checkISArray(data: any): boolean {
    if (!data) {
      return false;
    }
    if (Array.isArray(data) && data.length > 0) {
      return true;
    }
    return false;
  }

  static checkIsNotNull(data): boolean {
    if (data == null || data === undefined) {
      return false;
    }
    if (data === "") {
      return false;
    }
    return true;
  }

  static removeVietnameseTones(str): string {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      // str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
    }
    return str;
  }

  static removeVietnameseTonesInclueSpace(str): string {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      str = str.trim();
    }
    return str;
  }

  static removeSpecialCharacterForMermaid(str): string {
    if (str) {
      str = str.replace(/@|\(|\)|\[|\]|\{|\}|~|\||;|\"|\</g, "_");
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
    }
    return str;
  }

  static validateCode(code: string) {
    if (code === "") return;
    const regex: any = /[^a-zA-Z0-9._-]/;
    return regex.test(code);
  }

  static validateYear(year: string) {
    if (year === "") return;
    const regex: any = /^(19|20)\d{2}$/;
    return regex.test(year);
  }

  static validateMonth(month: string) {
    if (month === "") return;
    const regex: any = /^(0?[1-9]|1[012])$/;
    return regex.test(month);
  }

  static validatePhoneNotRequireField(code: string) {
    if (code == "" || code == null) return true;
    // const regex :any = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const regex: any = /^((\+84-?)|0)[0-9]{9}$/;
    return regex.test(code);
  }

  static validateJustNumber(code: string) {
    if (code == "" || code == null) return true;
    const regex: any = /^\d+$/;
    return regex.test(code);
  }

  static validateEmailNotRequireField(email: string): boolean {
    if (email === "" || isEmpty(email)) return true;
    // const regex: any = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const regex: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  static validateNIDNotRequireField(nid: string): boolean {
    if (nid == "" || nid == null) return true;
    // const regex: any = /(^\d{9}$)|(^\d{12}$)/;
    const regex: any = /^\d{12}$/;
    return regex.test(nid);
  }

  static validatePassportCode(nid: string): boolean {
    if (nid == "" || nid == null) return true;
    // const regex: any = /^[A-Z]{1}[0-9]{7}$/;
    const regex: any = /^[A-Za-z0-9]{6,15}$/;
    return regex.test(nid);
  }

  static validateInputJustOnlyWhiteSpace(value: string): boolean {
    const regex: any = /^(\s+\S+\s*)*(?!\s).*$/;
    return regex.test(value);
  }

  static validateInputJustOneWord(value: string): boolean {
    const regex: any = /^[\p{L}]+$/u;
    return regex.test(value);
  }

  static checkIsString(str: any): boolean {
    return typeof str === "string" || str instanceof String;
  }

  static getDateTime(value): Date {
    let timeMilis: Date;
    if (value) {
      timeMilis = UtilCommon.checkIsString(value) ? new Date(value) : value._d;
    }
    // return timeMilis;
    return moment(timeMilis).endOf("day").toDate();
  }

  static formatPartitionKey(value: any): string {
    if (value && (typeof value === "number" || typeof value === "string")) {
      value = new Date(value);
      const month =
        value.getMonth() + 1 > 9
          ? value.getMonth() + 1
          : "0" + (value.getMonth() + 1);
      return `${value.getFullYear()}${month}`;
    }
  }

  static validateSpecialCharacterExceptAccented(text: string): boolean {
    if (text === "" || text === null) return true;
    const regex: any = /^[^*|\.":<>[\]{}`\\()';@&$!,#%^/~=+_-]+$/;
    return regex.test(text);
  }

  static validateSpecialCharacterLessMore(text: string): boolean {
    if (text === "" || text === null) return true;
    const regex: any = /^[^<>]+$/;
    return regex.test(text);
  }

  static inputFieldOnlyNumber(event: any): boolean {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      return true;
    }
    return false;
  }

  static keyPressOnlyNumber(event: any) {
    const checkNotNumber = UtilCommon.inputFieldOnlyNumber(event);
    if (checkNotNumber) {
      event.preventDefault();
    }
  }

  static keyPressCode(event: any): void {
    const pattern = /[^a-zA-Z0-9._-]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  static keyPressValue(event: any): void {
    const pattern = /[^a-zA-Z0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  static convertJsonSchemaForm(data: any, readonly: any): any {
    let lstFields = data;
    let schema = {
      type: "object",
      properties: {},
      required: [],
    };
    let required = [];
    let layout = [];
    let lstLayoutObj = [];
    for (let obj of lstFields) {
      let key = obj.key;
      let title = obj.title;
      let enumF = obj.enum;
      let lstEnumValue = [];
      let lstEnum = [];
      if (enumF && enumF.length > 0) {
        for (let objE of enumF) {
          let enumValue = objE.value;
          let enumTitle = objE.title;
          lstEnumValue.push(enumValue);
          lstEnum.push({ value: enumValue, name: enumTitle });
        }
      }
      let type = obj.type;
      let layoutObj = {};
      if (type === "date") {
        schema.properties[key] = { type: "string" };
        layoutObj = { key: key, title: title, type: "date" };
      } else if (type === "text") {
        schema.properties[key] = { type: "string" };
        layoutObj = { key: key, title: title, type: "text" };
      } else if (type === "textarea") {
        schema.properties[key] = { type: "string" };
        layoutObj = { key: key, title: title, type: "textarea" };
      } else if (type === "number") {
        schema.properties[key] = { type: "number" };
        layoutObj = { key: key, title: title, type: "number" };
      } else if (type === "select") {
        schema.properties[key] = { type: "string", enum: lstEnumValue };
        layoutObj = {
          key: key,
          title: title,
          type: "select",
          titleMap: lstEnum,
        };
      } else if (type === "radios") {
        schema.properties[key] = { type: "string", enum: lstEnumValue };
        layoutObj = {
          key: key,
          title: title,
          type: "radios",
          titleMap: lstEnum,
        };
      } else if (type === "checkboxes") {
        schema.properties[key] = {
          type: "array",
          items: {
            type: "string",
            enum: lstEnumValue,
          },
        };
        layoutObj = {
          key: key,
          title: title,
          type: "checkboxes",
          titleMap: lstEnum,
        };
      }
      if (readonly) {
        layoutObj["readonly"] = true;
      }
      lstLayoutObj.push(layoutObj);
      let isRequired = obj.isRequired;
      if (isRequired && !readonly) {
        required.push(key);
      }
    }
    schema.required = required;

    for (let i = 0; i < lstLayoutObj.length; i = i + 2) {
      let left = lstLayoutObj[i];
      let right = i + 1 < lstLayoutObj.length ? lstLayoutObj[i + 1] : null;
      if (left && right) {
        let itemsLeft = [];
        itemsLeft.push(left);
        itemsLeft.push({
          type: "div",
          "flex-grow": "0",
          "flex-shrink": "0",
          "flex-basis": "0.5rem",
        });

        let itemsRight = [];
        itemsRight.push({
          type: "div",
          "flex-grow": "0",
          "flex-shrink": "0",
          "flex-basis": "0.5rem",
        });
        itemsRight.push(right);
        let items = [
          {
            type: "flex",
            "flex-flow": "row wrap",
            "flex-basis": "48%",
            "justify-content": "center",
            items: itemsLeft,
          },
          {
            type: "flex",
            "flex-flow": "row wrap",
            "flex-basis": "48%",
            "justify-content": "center",
            items: itemsRight,
          },
        ];
        layout.push({
          type: "flex",
          "flex-flow": "row wrap",
          "justify-content": "center",
          items: items,
        });
      } else {
        // layout.push(left);
        let itemsLeft = [];
        itemsLeft.push(left);
        itemsLeft.push({
          type: "div",
          "flex-grow": "0",
          "flex-shrink": "0",
          "flex-basis": "0.5rem",
        });
        let items = [
          {
            type: "flex",
            "flex-flow": "row wrap",
            "flex-basis": "48%",
            "justify-content": "center",
            items: itemsLeft,
          },
          {
            type: "flex",
            "flex-flow": "row wrap",
            "flex-basis": "48%",
            "justify-content": "center",
            items: [
              {
                type: "div",
                "flex-grow": "0",
                "flex-shrink": "0",
                "flex-basis": "0.5rem",
              },
            ],
          },
        ];
        layout.push({
          type: "flex",
          "flex-flow": "row wrap",
          "justify-content": "center",
          items: items,
        });
      }
    }

    return {
      schema: schema,
      layout: layout,
      data: {},
      options: {
        addSubmit: false,
      },
    };
  }

  static removeExtFile(fileName: string): string {
    if (fileName?.lastIndexOf(".") > -1) {
      return fileName?.substring(0, fileName?.lastIndexOf("."));
    }
    return fileName;
  }

  static formatPrice_VND(value: any, currency_VND = ""): any {
    if (!value) {
      return 0 + currency_VND;
    }
    if (isNaN(value)) {
      return value + currency_VND;
    }
    if (value === 0) {
      return value + currency_VND;
    }
    let sign = value == (value = Math.abs(value));
    value = Math.floor(value * 100 + 0.50000000001);
    value = Math.floor(value / 100).toString();
    for (
      let i = 0, length = Math.floor((value.length - (1 + i)) / 3);
      i < length;
      i++
    ) {
      value =
        value.substring(0, value.length - (4 * i + 3)) +
        "," +
        value.substring(value.length - (4 * i + 3));
    }
    return (sign ? "" : "-") + value + currency_VND;
  }

  static configNumberCurrency = {
    decimal: true,
    decimalLength: 3,
    decimalSeparator: ".",
    groupSeparator: ",",
  };

  static formatNumberCurrency(valueInput: any): any {
    if (!valueInput) {
      return 0;
    }
    valueInput = valueInput + "";
    if ((!valueInput && valueInput != 0) || valueInput.trim().length == 0) {
      return "";
    }

    let decimalValue = "";
    let decimalSeparator = "";
    let value = valueInput;

    if (valueInput.indexOf(this.configNumberCurrency.decimalSeparator) > -1) {
      let arr = valueInput.split(this.configNumberCurrency.decimalSeparator);
      value = arr[0];
      if (!value || value.length === 0) {
        value = "0";
      }
      decimalValue = arr[1];

      decimalSeparator = this.configNumberCurrency.decimalSeparator;
    }

    value = this.parseNumberCurrency(value);

    if (isNaN(value)) {
      return value + decimalSeparator + decimalValue;
    }
    if (value === 0) {
      return value + decimalSeparator + decimalValue;
    }
    let sign = value == (value = Math.abs(value));
    value = Math.floor(value * 100 + 0.50000000001);
    value = Math.floor(value / 100).toString();
    for (
      let i = 0, length = Math.floor((value.length - (1 + i)) / 3);
      i < length;
      i++
    ) {
      value =
        value.substring(0, value.length - (4 * i + 3)) +
        this.configNumberCurrency.groupSeparator +
        value.substring(value.length - (4 * i + 3));
    }
    value = value + decimalSeparator + decimalValue;
    return (sign ? "" : "-") + value;
  }

  static parseNumberCurrency(value: any): any {
    if ((!value && value != 0) || value.trim().length == 0) {
      return null;
    }
    let strValue: string = "";

    strValue = value.split(this.configNumberCurrency.groupSeparator).join("");
    strValue = strValue.replace(
      this.configNumberCurrency.decimalSeparator,
      "."
    );

    return strValue;
  }

  static dataUrlToFile(dataUrl: string, filename: string): File | undefined {
    const arr = dataUrl.split(",");
    if (arr.length < 2) {
      return undefined;
    }
    const mimeArr = arr[0].match(/:(.*?);/);
    if (!mimeArr || mimeArr.length < 2) {
      return undefined;
    }
    const mime = mimeArr[1];
    const buff = Buffer.from(arr[1], "base64");
    return new File([buff], filename, { type: mime });
  }

  static replaceCharacterSpecial(str, character) {
    return str.toString().replaceAll(character, "");
  }

  static convertStringToHex(str: string): string {
    let result = "";
    for (let i = 0; i < str.length; i++) {
      result += str.charCodeAt(i).toString(16);
    }
    return result;
  }

  static getRandomString(): string {
    const letters = "0123456789abcdefghijklmnopqrstuyqw".split("");
    let _color = "";
    for (let i = 0; i < 15; i++) {
      _color += letters[Math.floor(Math.random() * 32)];
    }
    return _color;
  }

  static convertHexToString(hex: string): string {
    let str = "",
      v;
    for (let i = 0; i <= hex.length; i += 2) {
      if (i < 2) {
        v = parseInt(hex.substring(0), 16);
      } else {
        v = parseInt(hex.substring(i, i - 2), 16);
      }
      if (v) {
        str += String.fromCharCode(v);
      }
    }
    return str;
  }

  static getJWTToken(type: string, token: any): string {
    // this._utils.getJWTToken('set', password);
    // token = 'jf6osjj10kit9l0.41626340313233343536.5mmcrjmj437ljno';
    if (type === "set") {
      const first = this.getRandomString(),
        last = this.getRandomString();
      token = first + "." + this.convertStringToHex(token) + "." + last;
    } else {
      let tempToken = token.split(".");
      if (Array.isArray(tempToken) && tempToken.length > 2) {
        tempToken = tempToken[1];
      }
      token = this.convertHexToString(tempToken);
    }
    return token;
  }

  static setRootPage(router, pageDefault, callback): void {
    router.navigate([pageDefault], { replaceUrl: true }).then(() => {
      if (callback) {
        callback.call();
      }
    });
  }

  static removeCheckTokenPage(hash): boolean {
    if (
      [
        "accept-member",
        "not-found",
        "forgot-password",
        "sign-up",
        "sign-in",
        "confirm-sign",
        "sign-document",
        "resetpass",
        "confirm-sign-social",
        "reset-password",
        "unlock-session",
        "survey",
        "verify-token",
      ].findIndex((h) => hash.indexOf(h) >= 0) >= 0
    ) {
      return true;
    }
    return false;
  }

  static parseNumberMoney(moneyFormatString: string): number {
    if (!moneyFormatString) return 0;
    if (moneyFormatString && moneyFormatString.includes(".")) {
      return parseInt(moneyFormatString.split(".").join(""), 10);
    } else {
      return parseInt(moneyFormatString, 10);
    }
  }

  static formatNumberCurrencyVND(moneyFormatNumber: number): string {
    const formatCurrency = moneyFormatNumber.toLocaleString("it-IT", {
      style: "currency",
      currency: "VND",
    });
    return formatCurrency;
  }

  static genTenantCode(): string {
    // let ATHENA = {
    //     'https://idms-uat.a4b.vn': true,
    //     'https://ilms-uat.a4b.vn': true,
    //     'https://icrm-uat.a4b.vn': true,
    //     'https://hunt-uat.a4b.vn': true,
    //     'https://athenaomni.athenafs.io': true,
    //     'https://athenahunt.athenafs.io': true,
    //     'https://athenashield.athenafs.io': true,
    //     'https://athenacastle.athenafs.io': true,
    // }
    // let OTHER = {
    //     'https://omniuat.athenafs.io': true,
    //     'https://huntuat.athenafs.io': true,
    //     'https://shielduat.athenafs.io': true,
    //     'https://castleuat.athenafs.io': true,
    // }
    // const origin = window.location.origin;
    // if (ATHENA[origin]) {
    //     return 'GALAXY';
    // }
    // if (OTHER[origin]) {
    //     return 'GALAXY_STAGING';
    // }
    return "BROTHER";
  }

  static genSettingsApp() {
    let LOGO_APP: string = "";
    if (window.location.href.indexOf("uat.athenafs.io") > -1) {
      LOGO_APP = "assets/images/logo/logo_staging.svg";
    } else {
      LOGO_APP = "assets/images/logo/logo.png";
    }
    return {
      LOGO_APP: LOGO_APP,
    };
  }

  public static isGreaterWithMonth(
    startDate: moment.Moment,
    endDate: moment.Moment,
    month: number
  ) {
    const diffInMonths = endDate.diff(startDate, "months");
    return diffInMonths > month;
  }

  static formatNumber(valueInput: any): any {
    if (!valueInput) {
      return 0;
    }
    valueInput = valueInput + "";
    if ((!valueInput && valueInput != 0) || valueInput.trim().length == 0) {
      return "";
    }

    let value = valueInput;

    let sign = value == (value = Math.abs(value));
    value = Math.floor(value * 100 + 0.50000000001);
    value = Math.floor(value / 100).toString();
    for (
      let i = 0, length = Math.floor((value.length - (1 + i)) / 3);
      i < length;
      i++
    ) {
      value =
        value.substring(0, value.length - (4 * i + 3)) +
        "." +
        value.substring(value.length - (4 * i + 3));
    }
    return (sign ? "" : "-") + value;
  }

  static genAggId(): string {
    return uuidv4();
  }

  static genDateNow(): string {
    return moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.000Z");
  }

  static convertStringToNumber(input: string | null): number | null {
    // Check if the input is null
    if (input === null) {
      return null; // Return null if input is null
    }

    // Check if the input is a mathematical expression
    if (
      input.includes("/") ||
      input.includes("*") ||
      input.includes("+") ||
      input.includes("-")
    ) {
      // Evaluate the expression safely
      return Function(`'use strict'; return (${input})`)();
    } else {
      // Convert numeric strings to numbers
      return Number(input);
    }
  }

  static convertTimestampToDate(timestamp: any): string {
    if (!isNaN(timestamp) && timestamp) {
      return moment(timestamp).format("YYYY-MM-DDTHH:mm:ss.000Z");
    }
    return moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.000Z");
  }

  static convertJsonb(input): string {
    if (!input) return "";
    return (
      "{" +
      Object.entries(JSON.parse(input))
        .map(([key, value]) => `${key}: "${value}"`)
        .join() +
      "}"
    );
  }
  static objectsAreEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  static isObjectWithMulLangeKey(obj: any): boolean {
    return Object.keys(obj)?.includes("vi") && Object.keys(obj)?.includes("en");
  }

  static convertObjectForGraphql(input, isKeepEmpty: boolean = false): any {
    let returnObj = {};
    for (let key in input) {
      if (input[key]) {
        if (typeof input[key] === "object") {
          if (input[key].hasOwnProperty("__typename")) {
            delete input[key]["__typename"];
          }
          if (UtilCommon.isArray(input[key], true)) {
            returnObj[key] = [];
            for (let obj of input[key]) {
              returnObj[key].push(UtilCommon.convertJsonbExt(obj));
            }
          } else {
            returnObj[key] = UtilCommon.convertJsonbExt(input[key]);
          }
        } else if (typeof input[key] === "string") {
          returnObj[key] = '"' + input[key] + '"';
        } else if (
          (input[key] as number) &&
          UtilCommon.isTimestamp((input[key] as number) || 0)
        ) {
          returnObj[key] =
            '"' + UtilCommon.convertTimestampToDate(input[key]) + '"';
        } else {
          returnObj[key] = input[key];
        }
      } else if (isKeepEmpty) {
        returnObj[key] = input[key];
      }
    }
    return returnObj;
  }

  static deleteTypeName(input): void {
    for (let key in input) {
      if (input[key]) {
        if (typeof input[key] === "object") {
          if (input[key].hasOwnProperty("__typename")) {
            delete input[key]["__typename"];
          }
        }
      }
    }
  }

  static convertJsonbExt(input): string {
    if (!input) return "";
    input = typeof input === "string" ? JSON.parse(input) : input;
    Object.keys(input).forEach((k) => !input[k] && delete input[k]);
    return (
      "{" +
      Object.entries(input)
        .map(([key, value]) => {
          if (UtilCommon.isArray(value)) {
            const result = `${key}: ${UtilCommon.convertJsonbArrayExt(value)}`;
            return result;
          } else if (typeof value === "object") {
            return `${key}: ${this.convertJsonbExt(value)}`;
          } else if (typeof value === "string") {
            return `${key}: "${value}"`;
          } else {
            return `${key}: ${value}`;
          }
        })
        .join() +
      "}"
    );
  }

  static convertJsonbArrayExt(input): string {
    if (!input) return "";
    let returnString = "[";
    for (let i of Object.assign([], input)) {
      if (typeof i === "object") {
        returnString += this.convertJsonbExt(i) + ",";
      } else {
        returnString += `"${i}"` + ",";
      }
    }
    returnString = returnString.slice(0, returnString.length - 1);
    returnString += "]";
    return returnString;
  }

  static convertObjectJsonb(input): string {
    if (!input) return "";
    return (
      "{" +
      Object.entries(input)
        .map(([key, value]) => `${key}: ${value ? value : `"${value}"`}`)
        .join() +
      "}"
    );
  }

  static convertObjectJsonHtml(obj) {
    const newObj = {};

    for (const key in obj) {
      if (typeof obj[key] === "string" && /<[^>]*>/.test(obj[key])) {
        // If the value is a string and contains HTML tags, escape the HTML tags
        newObj[key] = obj[key].replace(/</g, "&lt;").replace(/>/g, "&gt;");
      } else {
        newObj[key] = obj[key];
      }
    }

    return JSON.stringify(newObj);
  }

  static createFtsStringWithObjectField(
    request: any,
    removeField: string
  ): string {
    const newObject = { ...request };
    if (removeField) {
      delete newObject[removeField];
    }
    const customFtsString = Object.values(newObject).join(" ");
    const customFtsStringWithFieldName = Object.values(
      JSON.parse(request[removeField])
    ).join(" ");
    return `${customFtsString} ${customFtsStringWithFieldName}`;
  }

  static createFtsStringWithObjectFieldList(
    request: any,
    removeFieldList: string[]
  ): string {
    const newObject = { ...request };
    let customFtsStringWithFieldName = "";

    if (removeFieldList && Array.isArray(removeFieldList)) {
      for (const field of removeFieldList) {
        if (field in newObject) {
          customFtsStringWithFieldName +=
            " " + Object.values(JSON.parse(newObject[field])).join(" ");
          delete newObject[field];
        }
      }
    }

    const customFtsString = Object.values(newObject).join(" ");
    return `${customFtsString} ${customFtsStringWithFieldName}`;
  }

  static createFtsStringWithObjectFieldListExt(
    object: any,
    removeFieldList: string[] = []
  ): string {
    const newObject = { ...object };
    let customFtsStringWithFieldName = "";

    for (let key in newObject) {
      if (removeFieldList.indexOf(key) > -1) {
        continue;
      }
      if (newObject[key]) {
        customFtsStringWithFieldName +=
          (typeof newObject[key] === "object"
            ? newObject[key]?.name?.vi
              ? newObject[key]?.name?.vi + " " + newObject[key]?.name?.en
              : this.createFtsStringWithObjectFieldListExt(newObject[key], [])
            : newObject[key]) + " ";
      }
    }
    return `${customFtsStringWithFieldName}`;
  }

  static convertJsonbArray(input): string {
    if (!input) return "";
    return (
      "{" +
      Object.entries(JSON.parse(input))
        .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
        .join() +
      "}"
    );
  }

  static convertObjectToJsonStringify(formValue) {
    return Object.keys(formValue).reduce((acc, key, index) => {
      let convertItem = formValue[key];
      if (
        UtilCommon.canParseJSON(formValue[key]) &&
        typeof JSON.parse(formValue[key]) === "object"
      ) {
        if (UtilCommon.isAnyValueAnArray(JSON.parse(formValue[key]))) {
          convertItem = UtilCommon.convertJsonbArray(formValue[key]);
        } else {
          convertItem = UtilCommon.convertJsonb(formValue[key]);
        }
      } else if (typeof formValue[key] === "string") {
        convertItem = `"${formValue[key]}"`;
      }
      acc[key] = convertItem;
      return acc;
    }, {});
  }

  static convertObjectToJsonStringifyExt(request: any): void {
    for (let key in request) {
      if (request[key] && typeof request[key] === "object") {
        request[key] = UtilCommon.convertJsonbExt(request[key]);
      } else if (typeof request[key] === "string") {
        request[key] = '"' + request[key] + '"';
      }
    }
  }

  static deleteNullValue(obj) {
    for (const key in obj) {
      if (obj[key] === null || obj[key] === undefined) {
        delete obj[key];
      }
    }
    return obj;
  }

  static canParseJSON(value) {
    try {
      JSON.parse(value);
      return true; // If parsing succeeds, return true
    } catch (e) {
      return false; // If parsing fails, return false
    }
  }

  static parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null; // If parsing fails, return false
    }
  }

  static nestedParse(value) {
    try {
      return UtilCommon.parseJson(JSON.parse(value));
    } catch (e) {
      return value;
    }
  }
  static parseJsonString(value) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (e) {
      return null; // If parsing fails, return false
    }
  }

  static isTimestamp(timestamp: number): boolean {
    if (!timestamp) return false;
    const timestampForYear2000 = 946684800000;
    const timestampForYear3000 = 32503680000000;
    return (
      typeof timestamp === "number" &&
      timestamp > timestampForYear2000 &&
      timestamp < timestampForYear3000
    );
  }

  static createFtsString(request: any): string {
    const customFtsString = Object.values(request).join(" ");
    return `${customFtsString}`;
  }

  static convertStringToTimestamp(value: string): number {
    if (!value) return new Date().getTime();
    const dateObj = new Date(value);
    const timestamp = dateObj.getTime();
    return timestamp;
  }

  static _processCloneObjectValue(cloneObjectValue) {
    for (const [key, value] of Object.entries(cloneObjectValue)) {
      if (value === null || (Array.isArray(value) && value.length === 0)) {
        delete cloneObjectValue[key];
      }
      if (UtilCommon.isTimestamp((value as number) || 0)) {
        cloneObjectValue[key] = UtilCommon.convertTimestampToDate(value);
      }
    }
    return cloneObjectValue;
  }

  static deepClone<T>(input): T {
    return JSON.parse(JSON.stringify(input));
  }

  static deepCloneAny(input) {
    return JSON.parse(JSON.stringify(input));
  }

  static isAnyValueAnArray(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          return true;
        }
      }
    }
    return false;
  }

  static convertTimeWithouTimezone(value: any): string {
    const utcDate = moment.utc(value);
    const formattedDate = utcDate.format("HH:mm:ss");
    return formattedDate;
  }

  static convertDateWithouTimezone(value: any): string {
    const utcDate = moment.utc(value);
    const formattedDate = utcDate.format("YYYY-MM-DDTHH:mm:ss");
    return formattedDate;
  }

  static getLabelLanguage(object: any): any {
    if (!object) {
      return "";
    }
    if (typeof object === "object") {
      if (localStorage.getItem("language") === "en" && object["en"]) {
        return object["en"] || object["vi"];
      } else if (object["vi"]) {
        return object["vi"] || object["en"];;
      } else if (object["en"]) {
        return object["en"] || object["vi"];
      } else if (object["name"] && typeof object["name"] === "object") {
        return UtilCommon.getLabelLanguage(object["name"]);
      } else if (object["fileName"]) {
        return object["fileName"];
      }
      return "";
    }

    return object;
  }

  static getValueByLanguage(input: Record<string, any> | string): string {
    if (typeof input === "string") {
      try {
        input = JSON.parse(input);
      } catch {
        // If input is not a valid JSON string, return it as is
        return input as string;
      }
    }

    if (typeof input === "object" && input !== null) {
      if (input?.name?.en || input?.name?.vi) {
        return input?.name?.en || input?.name?.vi;
      }
      const language = "en"; //localStorage.getItem('language') || 'en';
      return input[language] || input["en"] || input["vi"] || "";
    }

    return (input as string) || "";
  }

  // static getValueByLanguage(input: Record<string, any> | string):any {
  //   let result = "";
  //   if (typeof input === 'object') {
  //     if (localStorage.getItem("language") === "en" && input["en"]) {
  //       result = input["en"];
  //     } else if (input["vi"]) {
  //       result = input["vi"];
  //     } else if (input["en"]) {
  //       result = input["en"];
  //     }
  //   } else {
  //     result = input;
  //   }
  //   return result;
  // }

  static handleDeleteNameLanguage(object: any): any {
    if (!object) {
      return object;
    }
    if (
      object.hasOwnProperty("label") &&
      object.hasOwnProperty("name") &&
      typeof object["name"] === "object" &&
      object["name"]["vi"] &&
      object["name"]["en"]
    ) {
      let { label, ...clonedObject } = object;
      object = clonedObject;
      return object;
      // delete object['label'];
    }
    for (let key in object) {
      if (typeof object[key] === "object") {
        object[key] = UtilCommon.handleDeleteNameLanguage(object[key]);
      } else if (UtilCommon.isArray(object[key])) {
        for (let obj of object[key]) {
          if (typeof obj === "object") {
            obj = UtilCommon.handleDeleteNameLanguage(obj);
          }
        }
      }
    }

    return object;
  }

  static splitPhone(phoneWithDialCode: string): {
    dialCode: string;
    phone: string;
  } {
    return {
      dialCode: phoneWithDialCode.split(" ")?.[0] || null,
      phone: phoneWithDialCode.split(" ")?.[1] || null,
    };
  }

  static removeFieldNullOrUndefined(obj: any): any {
    const objCopy = JSON.parse(JSON.stringify(obj));
    for (let key in objCopy) {
      if (objCopy[key] === null || objCopy[key] === undefined) {
        delete objCopy[key];
      }
    }
    return objCopy;
  }

  static mergedArrayCellRender(arrayA, arrayB): any {
    const modifiedArray = arrayB.map((item) => {
      const { headerName, ...rest } = item;
      return rest;
    });
    const mergedArray: Array<any> = modifiedArray.map((elementB) => {
      const matchingElementA = arrayA.find(
        (elementA) => elementA.field === elementB.colId
      );

      if (matchingElementA) {
        return {
          ...elementB,
          pinned: elementB?.pinned || matchingElementA.pinned,
          width: elementB?.width || matchingElementA.width,
          maxWidth: elementB?.maxWidth || matchingElementA.maxWidth,
          minWidth: elementB?.minWidth || matchingElementA.minWidth,
          cellRenderer: matchingElementA.cellRenderer,
          onCellClicked: matchingElementA?.onCellClicked,
          tooltipValueGetter: matchingElementA?.tooltipValueGetter,
          headerName: matchingElementA?.headerName,
        };
      } else {
        return elementB;
      }
    });
    return mergedArray;
  }

  static getPropertyValue(object: Object, key: string) {
    return object.hasOwnProperty(key) ? object[key] : null;
  }

  static setGraphqlAction(action: string): void {
    localStorage.setItem(AppStateConstant.GraphqlAction, action);
  }

  static compareDates(date1: string, date2: string): number {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    if (d1 > d2) {
      return 1; // date1 is later than date2
    } else if (d1 < d2) {
      return -1; // date1 is earlier than date2
    } else {
      return 0; // date1 is equal to date2
    }
  }

  static getClosestDate(
    items: { date: string }[],
    referenceDate: string = new Date().toISOString()
  ): string | null {
    if (!items || items.length === 0) {
      return null; // Return null if there are no items
    }

    const refDate = new Date(referenceDate);

    // Find the resume with the closest approveDate
    const closestResume = items.reduce((closest, current) => {
      const currentDate = new Date(current.date);
      const closestDate = new Date(closest.date);

      // Compare the absolute difference between the dates
      return Math.abs(currentDate.getTime() - refDate.getTime()) <
        Math.abs(closestDate.getTime() - refDate.getTime())
        ? current
        : closest;
    });

    return closestResume.date;
  }

  static getLatestDate<T>(items: Array<{ date: string } & T>): T {
    if (!items || items.length === 0) {
      return null; // Return null if there are no items
    }

    // Find the resume with the latest date
    const latestResume = items.reduce((latest, current) => {
      const currentDate = new Date(current.date);
      const latestDate = new Date(latest.date);

      return currentDate > latestDate ? current : latest;
    });

    return latestResume;
  }

  static compareObjects(
    newDataObject: any,
    oldDataObject: any,
    editorList: any = [],
    isSkip: boolean = true,
    escapeSkips: string[] = []
  ): any {
    if (
      UtilCommon.isNotNull(newDataObject) &&
      UtilCommon.isNotNull(oldDataObject)
    ) {
      const skips = [
        "app_code",
        "appCode",
        "create_date",
        "createDate",
        "fts_string",
        "ftsString",
        "fts_value",
        "ftsValue",
        "id",
        "maker_date",
        "makerDate",
        "mod_no",
        "modNo",
        "record_order",
        "recordOrder",
        "record_status",
        "recordStatus",
        "stage",
        "status",
        "task_key",
        "taskKey",
        "task_status",
        "taskStatus",
        "tenant_code",
        "tenantCode",
        "update_date",
        "updateDate",
        "response_form",
        "job_track_ids",
        "benefit",
        "act_address",
        "reg_address",
        "act_fulladdress"
      ];
      // remove escape skips from skips array
      if (escapeSkips.length > 0) {
        escapeSkips.forEach((escapeSkip) => {
          const index = skips.indexOf(escapeSkip);
          if (index > -1) {
            skips.splice(index, 1);
          }
        });
      }

      const differentFields: any[] = [];
      // Get keys from both objects
      const keysA = Object.keys(newDataObject);
      const keysB = Object.keys(oldDataObject);
      // Combine and get unique keys
      const allKeys = Array.from(new Set([...keysA, ...keysB]));

      for (let key of allKeys) {
        if (
          isSkip &&
          (skips.includes(key) || key.endsWith("_id") || key.endsWith("Id"))
        ) {
          continue; // Skip comparison for these keys
        }
        let newData = UtilCommon.getKeyObjectJson(newDataObject[key]);
        let oldData = UtilCommon.getKeyObjectJson(oldDataObject[key]);
        let newDataLabel = UtilCommon.getLabelLanguage(newDataObject[key]);
        let oldDataLabel = UtilCommon.getLabelLanguage(oldDataObject[key]);
        if (key.toLowerCase().endsWith("mobile") || key.toLowerCase().endsWith("phone")) {
          if (UtilCommon.isNumber(newData)) {
            newData = newData + '';
            newDataLabel = newDataLabel + '';
          }
          if (UtilCommon.isDate(oldData)) {
            oldData = oldData + '';
            oldDataLabel = oldDataLabel + '';
          }
        } else if (key.toLowerCase().endsWith("date") || key.toLowerCase() === "dob") {
          if (UtilCommon.isDate(newData)) {
            newData = UtilCommon.formatDate(newData);
            newDataLabel = UtilCommon.formatDate(newDataLabel);
          }
          if (UtilCommon.isDate(oldData)) {
            oldData = UtilCommon.formatDate(oldData);
            oldDataLabel = UtilCommon.formatDate(oldDataLabel);
          }
        } else if (key.toLowerCase().endsWith("flg")) {
          if (newData) {
            newData = "Yes";
            newDataLabel = "Yes";
          } else {
            newData = "No";
            newDataLabel = "No";
          }
          if (oldData) {
            oldData = "Yes";
            oldDataLabel = "Yes";
          } else {
            oldData = "No";
            oldDataLabel = "No";
          }
        } else if (newData && oldData &&
          (UtilCommon.isArray(newData) ||
            (UtilCommon.isArray(oldData) &&
              newData.every((item) => UtilCommon.hasRequiredProperties(item)) &&
              oldData.every((item) => UtilCommon.hasRequiredProperties(item))))
        ) {
          let concatenatedStringNew = "";
          for (let i = 0; i < newData.length; i++) {
            concatenatedStringNew += UtilCommon.getLabelLanguage(
              newData[i].name ? newData[i].name : newData[i]
            );
            if (i !== newData.length - 1) {
              concatenatedStringNew += ", ";
            }
          }
          newData = concatenatedStringNew;
          newDataLabel = concatenatedStringNew;

          let concatenatedStringOld = "";
          for (let i = 0; i < oldData.length; i++) {
            concatenatedStringOld += UtilCommon.getLabelLanguage(
              oldData[i].name ? oldData[i].name : oldData[i]
            );
            if (i !== oldData.length - 1) {
              concatenatedStringOld += ", ";
            }
          }
          oldData = concatenatedStringOld;
          oldDataLabel = concatenatedStringOld;
        } else {
          if (UtilCommon.isNumber(newData)) {
            newData = UtilCommon.formatNumberCurrency(newData);
            newDataLabel = UtilCommon.formatNumberCurrency(newDataLabel);
          }
          if (UtilCommon.isNumber(oldData)) {
            oldData = UtilCommon.formatNumberCurrency(oldData);
            oldDataLabel = UtilCommon.formatNumberCurrency(oldDataLabel);
          }
        }
        if (
          (!UtilCommon.isEmpty(newData) || !UtilCommon.isEmpty(oldData)) &&
          newData !== oldData &&
          newDataLabel !== oldDataLabel
        ) {
          differentFields.push({
            fieldName: key,
            newData: newDataLabel,
            oldData: oldDataLabel,
          });
        }
      }

      if (UtilCommon.isArray(differentFields, true)) {
        if (UtilCommon.isArray(editorList, true)) {
          differentFields.forEach((item) => {
            if (editorList.includes(item.fieldName)) {
              item.isEditor = true;
            }
          });
        }
      }
      return differentFields;
    }
    return [];
  }

  static isEmpty(param: any): boolean {
    if (param === "" || param === 0) {
      return true; // Empty string
    }

    if (Array.isArray(param) && param.length === 0) {
      return true; // Empty array
    }

    if (param instanceof Object && Object.keys(param).length === 0) {
      return true; // Empty object
    }

    return false; // Not empty
  }

  static hasRequiredProperties(item: any): boolean {
    return item instanceof Object && "id" in item && "name" in item && "code" in item;
  }

  static getKeyObjectJson(value, field: any = ""): any {
    if (value instanceof Object) {
      if (field && value[field]) {
        return value[field];
      }
      if (value["id"]) {
        return value["id"];
      }
      if (value["en"]) {
        return value["en"];
      }
      if (value["vi"]) {
        return value["vi"];
      }
    }
    return value;
  }

  static distanceDateUtilNow(input: string): number {
    let date1 = new Date(input).getTime();
    let date2 = new Date().getTime();
    let distanceDays = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

    return distanceDays;
  }

  static formatMillisecondsToTimeText(milliseconds: number): string {
    const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
    const years = Math.floor(days / 365);
    const months = Math.floor((days % 365) / 30);
    const remainingDays = days % 30;
    const timeParts: string[] = [];
    if (years > 0) {
      timeParts.push(`${years} year${years > 1 ? "s" : ""}`);
    }
    if (months > 0) {
      timeParts.push(`${months} month${months > 1 ? "s" : ""}`);
    }
    if (remainingDays > 0) {
      timeParts.push(`${remainingDays} day${remainingDays > 1 ? "s" : ""}`);
    }

    return timeParts.join(" ");
  }

  static parseDateFlexibleToStringText(dateString: string): Date | null {
    // Add null/undefined check at the beginning
    if (!dateString || dateString === null || dateString === undefined) {
      return null;
    }
    // Normalize the input string (trim whitespace and convert to lowercase for easier matching)
    const normalizedDateString = dateString.trim().toLowerCase();

    // Handling cases like 'present', 'now', 'current'
    const specialCases = ["present", "now", "current", "today"];
    if (specialCases.includes(normalizedDateString)) {
      return new Date(); // Return current date for these inputs
    }

    // Patterns for different date formats
    const patterns = [
      {
        regex: /^(\d{2})\/(\d{2})\/(\d{4})$/,
        parse: (match) => new Date(+match[3], +match[2] - 1, +match[1]),
      }, // dd/mm/yyyy
      {
        regex: /^(\d{2})\/(\d{2})\/(\d{4})$/,
        parse: (match) => new Date(+match[3], +match[1] - 1, +match[2]),
      }, // mm/dd/yyyy
      {
        regex: /^tháng (\d{1,2}) năm (\d{4})$/,
        parse: (match) => new Date(+match[2], +match[1] - 1),
      }, // Vietnamese "Tháng X năm YYYY"
      {
        regex: /^(\d{4})-(\d{2})-(\d{2})$/,
        parse: (match) => new Date(+match[1], +match[2] - 1, +match[3]),
      }, // ISO "YYYY-MM-DD"
      {
        regex: /^(\d{2})-(\d{2})-(\d{4})$/,
        parse: (match) => new Date(+match[3], +match[2] - 1, +match[1]),
      }, // "DD-MM-YYYY"
      {
        regex: /^([a-z]+)\s(\d{4})$/,
        parse: (match) => new Date(Date.parse(`${match[1]} 1, ${match[2]}`)),
      }, // "Month YYYY" (e.g., June 2023)
      {
        regex: /^(\d{2})\s([a-z]+)\s(\d{4})$/,
        parse: (match) =>
          new Date(Date.parse(`${match[2]} ${match[1]}, ${match[3]}`)),
      }, // "DD Month YYYY"
      {
        regex: /^([a-z]+)\s(\d{2}),\s(\d{4})$/,
        parse: (match) =>
          new Date(Date.parse(`${match[1]} ${match[2]}, ${match[3]}`)),
      }, // "Month DD, YYYY" (e.g., June 13, 2023)
    ];

    // Try to match each pattern
    for (const { regex, parse } of patterns) {
      const match = normalizedDateString.match(regex);
      if (match) {
        return parse(match);
      }
    }

    // Attempt native Date parsing as a fallback (for less common formats)
    const fallbackDate = new Date(dateString);
    if (!isNaN(fallbackDate.getTime())) {
      return fallbackDate;
    }

    // Return null if no pattern matched
    return null;
  }

  static compareDatesInMinutes(date1, date2) {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    // Calculate the difference in minutes
    const differenceInMinutes = momentDate2.diff(momentDate1, "minutes");

    return differenceInMinutes;
  }

  static normalizeString(str: string): string {
    return str.trim().toLowerCase().replace(/\s+/g, "");
  }

  static isMoreThanTimeUtilNow(
    fromDate: string,
    milliseconds: number
  ): boolean {
    // Convert date strings to Date objects
    const startDate: Date = new Date(fromDate);
    const endDate: Date = new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds: number =
      endDate.getTime() - startDate.getTime();
    return differenceInMilliseconds > milliseconds;
  }

  static daysUntilTime(time: string, milliseconds: number): number {
    // Convert the input time string to a Date object
    const targetDate: Date = new Date(time);

    // Get the current time
    const currentDate: Date = new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds: number =
      milliseconds - (targetDate.getTime() - currentDate.getTime());

    // Convert milliseconds to days
    const millisecondsInADay: number = 24 * 60 * 60 * 1000; // 24 hours
    const daysDifference: number = Math.floor(
      differenceInMilliseconds / millisecondsInADay
    );

    return daysDifference;
  }

  static convertStringToDate(dateString: string) {
    const valueTime = new Date(dateString).getTime();
    if (!isNaN(valueTime) && valueTime !== 0) {
      return new Date(dateString);
    }

    // Try parsing using different formats
    const formats = [
      "dd/mm/yyyy", // Day/Month/Year
      "mm/dd/yyyy", // Month/Day/Year
      "yyyy/mm/dd", // Year/Month/Day
    ];

    const parts = dateString.split("/").map(Number);

    let day, month, year;

    // Check if input could be yyyy/mm/dd (when the first part is greater than 31)
    if (parts[0] > 31) {
      [year, month, day] = parts;
    }
    // Check if input could be dd/mm/yyyy (when the second part is <= 12)
    else if (parts[1] <= 12) {
      [day, month, year] = parts;
    }
    // Otherwise, assume it's mm/dd/yyyy
    else {
      [month, day, year] = parts;
    }

    // Create and return the Date object
    return new Date(year, month - 1, day); // Month is 0-based, so subtract 1
  }

  static capitalizeFirstCharacterOfWords(input: string): string {
    if (!input) {
      return "";
    }

    input = this.replaceTA(input);

    const uppercaseWords = [
      "HRBP",
      "TA",
      "DEPT",
      "DEPTHEAD",
      "TAM",
      "C&B",
      "IT&AF"
    ];
    const preposition = [
      "at",
      "on",
      "by",
      "for",
      "to"
    ]

    let inputTemp = input
      .toLowerCase() // Convert the entire string to lowercase
      .split(/[\s_]+/) // Split the string into words based on spaces and underscores
      .map((word) => {
        // Check if the word should be uppercased
        if (uppercaseWords.includes(word.toUpperCase())) {
          return word.toUpperCase(); // Convert to uppercase if it matches
        }
        return preposition.indexOf(word) > -1 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1); // Capitalize first letter
      })
      .join(" "); // Join the words back into a single string

    return this.replaceTA(inputTemp);
  }

  static replaceTA(input): string {
    input = input.replace(/\bRrm\b/gi, "TAM");
    input = input.replace(/\bRRm\b/gi, "TAM");
    input = input.replace(/\bRRM\b/gi, "TAM");
    input = input.replace(/\brrm\b/gi, "TAM");
    input = input.replace(/\bRr\b/gi, "TA");
    input = input.replace(/\bRR\b/gi, "TA");
    input = input.replace(/\brr\b/gi, "TA");

    // Replace RRM with TAM and RR with TA
    input = input.replace(/\bRRM\b/gi, "TAM");
    input = input.replace(/\bRR\b/gi, "TA");
    input = input.replace(/TAM Official/gi, "TAM");
    return input;
  }

  static convertOnlineCandidateResume(status: string) {
    if (!status) {
      return '';
    }
    if (ONLINE_CANDIDATE_RESUME_STATUS.APPROVE === status.toUpperCase()) {
      status = 'Approved';
    } else if (ONLINE_CANDIDATE_RESUME_STATUS.REJECT === status.toUpperCase()) {
      status = 'Rejected';
    } if (ONLINE_CANDIDATE_RESUME_STATUS.CANCEL === status.toUpperCase()) {
      status = 'Withdrawn';
    }
    return status;
  }
  static getNameFromEmail(email: string): string | null {
    if (!email) {
      return "";
    }

    if (email === 'sys_recruit@vng.com.vn' || email === 'system_etl' || email === 'vng_core_sys') {
      return 'Talent System';
    } else if (email === 'sys_odoo@vng.com.vn') {
      return 'Odoo System';
    }

    // Check if the email is valid
    const atIndex = email.indexOf("@");
    if (atIndex === -1) {
      return email; // Return null if there's no '@' symbol
    }

    // Split the email at '@' and return the name part
    return email.split("@")[0];
  }

  static labelForEmployee(name, email): string {
    if (name && email) {
      return (
        UtilCommon.getNameFromEmail(email) +
        " - " +
        UtilCommon.getLabelLanguage(name)
      );
    } else if (name) {
      return UtilCommon.getLabelLanguage(name);
    } else if (email) {
      return UtilCommon.getNameFromEmail(email);
    }
    return "";
  }

  static replaceUrlWrong(url: string) {
    if (url.indexOf("api//") > -1 || url.indexOf("service//") > -1) {
      url = url.replace("api//", "api/");
      url = url.replace("service//", "service/");
    }
    return url;
  }

  static parseJwt(token: string) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map((c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    } catch (e) {
      return "";
    }
  }

  static replaceCharacter(str, strTemp, index, replacement) {
    return (
      strTemp.substring(0, index) +
      replacement +
      str.substring(index + replacement.length)
    );
  }

  static convertToVnd(number) {
    if (typeof number !== "number" || isNaN(number)) {
      return number;
    }
    return new Intl.NumberFormat("en-US").format(number);
  }

  static formatInterviewTime(date: any, format: any = "DD/MM/YYYY hh:mm A") {
    if (!date) {
      return '';
    }
    return moment(date).format(format);
  }

  static areDatesEqual(date1, date2) {
    // Convert the date strings to Date objects
    const [day1, month1, year1] = date1.split("/").map(Number);
    const [day2, month2, year2] = date2.split("/").map(Number);

    // Compare day, month, and year
    return day1 === day2 && month1 === month2 && year1 === year2;
  }

  static getOldestDate(
    dates: Array<Record<string, any>>,
    pickField: string = "date"
  ) {
    if (!dates || dates.length === 0) return null;

    // Sử dụng reduce để tìm đối tượng có pickField (date) cũ nhất
    return dates.reduce((oldest, current) => {
      return new Date(current?.[pickField]) < new Date(oldest?.[pickField])
        ? current
        : oldest;
    });
  }

  static checkIncludesLabel(obj, value, isSearchCode: boolean = false) {
    if (!value) {
      return false;
    }
    value = value.toLowerCase();
    if (isSearchCode) {
      if (obj?.code?.toLowerCase().includes(value) || obj?.displayCode?.toLowerCase().includes(value)) {
        return true;
      }
    }
    if (
      obj?.label &&
      (UtilCommon.removeVietnameseTonesInclueSpace(obj?.label)
        .toLowerCase()
        .includes(value) ||
        obj?.label?.toLowerCase().includes(value))
    ) {
      return true;
    }
    const name = obj?.name;
    if (name) {
      // Check if name is an object
      if (typeof name === "object" && name !== null) {
        return Object.values(name).some(
          (nameValue: string) =>
            nameValue && (UtilCommon.removeVietnameseTonesInclueSpace(nameValue)
              .toLowerCase()
              .includes(value) || nameValue.toLowerCase().includes(value))
        );
      }
      // If name is a string
      return (
        typeof name === "string" &&
        (UtilCommon.removeVietnameseTonesInclueSpace(name)
          .toLowerCase()
          .includes(value) ||
          name.toLowerCase().includes(value))
      );
    }

    return false;
  }

  static buildTree(itemList: any[]): any[] {
    const map = new Map<number, any>();
    const tree: any[] = [];

    // Build map of items
    itemList.forEach((item) => {
      map.set(item.id, { ...item, children: [] });
    });

    // Build the tree structure
    itemList.forEach((item) => {
      if (item.parentId === null) {
        tree.push(map.get(item.id)!); // Add root nodes
      } else {
        const parent = map.get(item.parentId);
        if (parent) {
          parent.children.push(map.get(item.id)!); // Add child to parent
        }
      }
    });

    return tree;
  }

  // Function to find the path to the root from a node with a specific id
  static findPathToRoot(id: number, nodes: any[], items: any[]): any[] {
    const pathIds: number[] = [];
    const pathObjects: any[] = [];

    const findNode = (node: any): boolean => {
      if (node.id === id) {
        pathIds.push(node.id); // Add current node id to path
        return true; // Node found
      }
      if (node.children) {
        for (const child of node.children) {
          if (findNode(child)) {
            pathIds.push(node.id); // Add parent id to path on the way up
            return true;
          }
        }
      }
      return false; // Node not found in this branch
    };

    // Search through root nodes
    for (const root of nodes) {
      if (findNode(root)) {
        break; // Stop after finding the node
      }
    }

    // Get full objects from the path IDs
    pathIds.reverse(); // Reverse to get the path from node to root
    pathIds.forEach((pathId) => {
      const item = items.find((item) => item.id === pathId);
      if (item) {
        pathObjects.push(item);
      }
    });

    return pathObjects;
  }

  static OverOneYear(date): boolean {
    const oneYearInMs = 365 * 24 * 60 * 60 * 1000; // Number of milliseconds in a year
    const now = new Date().getTime();
    return now - new Date(date).getTime() >= oneYearInMs;
  }

  static manipulateFilterControl(
    fieldConfigure: XAdvancedFilterControl,
    componentInstance: any,
    filterData: any,
    getDataSourceByKey: (key: string) => ICommonDataSource[]
  ) {
    const formControl = new FormControl();
    const destroy$ = new Subject();
    const originalDataSource = getDataSourceByKey(fieldConfigure.fieldName);
    const filterDataSource$ = new BehaviorSubject(
      originalDataSource.slice(0, 20)
    );

    fieldConfigure.filterControl = formControl;
    fieldConfigure.dataSource$ = filterDataSource$;

    formControl.valueChanges
      .pipe(
        takeUntil(destroy$),
        distinctUntilChanged(),
        startWith(""),
        tap((keyword: string) => {
          let formValue = componentInstance?.filterComp?.formValue;
          let fieldValue = [];
          if (formValue) {
            if (
              formValue[fieldConfigure?.fieldName] &&
              UtilCommon.isArray(formValue[fieldConfigure?.fieldName]?.values)
            ) {
              fieldValue.push(...formValue[fieldConfigure?.fieldName]?.values);
            }
          }
          if (filterData) {
            if (
              filterData[fieldConfigure?.fieldName] &&
              UtilCommon.isArray(filterData[fieldConfigure?.fieldName]?.values)
            ) {
              fieldValue.push(...filterData[fieldConfigure?.fieldName]?.values);
            }
          }

          if (!keyword) {
            const filterDataSource = originalDataSource.slice(0, 20);
            let mergedDataSource = filterDataSource;
            if (fieldValue.length > 0) {
              const valueBy = fieldConfigure?.valueBy;
              const objectsToMerge = originalDataSource.filter((item) =>
                fieldValue.includes(valueBy ? item[valueBy] : item["id"])
              );
              mergedDataSource = [
                ...filterDataSource,
                ...objectsToMerge.filter(objToMerge =>
                  !filterDataSource.some(existingObj => existingObj.id === objToMerge.id)
                )
              ];
            }
            filterDataSource$.next(mergedDataSource);
            return;
          }
          keyword = keyword.toLowerCase();
          filterDataSource$.next(
            originalDataSource.filter(
              (obj) =>
                (obj?.name?.en ?? '').toLowerCase().indexOf(keyword) > -1 ||
                (obj?.name?.vi ?? '').toLowerCase().indexOf(keyword) > -1 ||
                (obj?.label ?? '').toLowerCase().indexOf(keyword) > -1
            )
          );
        })
      )
      .subscribe();

    return function () {
      destroy$.next(null);
      destroy$.complete();
    };
  }

  static convertMinutesToFormat(minutes) {
    const minutesInHour = 60;
    const hoursInDay = 24;
    const daysInMonth = 30;

    // Calculate total hours and minutes
    const totalHours = Math.floor(minutes / minutesInHour);
    const remainingMinutes = Math.floor(minutes % minutesInHour);

    // Calculate the number of months, days, and hours
    const months = Math.floor(totalHours / (hoursInDay * daysInMonth));
    const remainingHoursAfterMonths = totalHours % (hoursInDay * daysInMonth);
    const days = Math.floor(remainingHoursAfterMonths / hoursInDay);
    const hours = remainingHoursAfterMonths % hoursInDay;

    // Construct the result string
    let result = [];
    if (months > 0) result.push(`${months} m`);
    if (days > 0) result.push(`${days} d`);
    if (hours > 0) result.push(`${hours} h`);
    if (remainingMinutes > 0) result.push(`${remainingMinutes} min`);

    return result.join(' ');
  }

  static convertMinutesToDays(minutes): string {
    const minutesInHour = 60;
    const hoursInDay = 24;

    // Calculate total hours
    const totalHours = Math.floor(minutes / minutesInHour);

    // Calculate the number of days
    const days = Math.floor(totalHours / hoursInDay);

    // Return result
    if (days === 1) {
      return `1 day`;
    } else if (days === 0) {
      return `0 day`;
    } else {
      return `${days} days`;
    }
  }

  static getMatchingProcessValue(selectedRows): any {
    const isOpening = selectedRows.every(row => CandidateStatusEnum.OPENING === row.status);
    const isOpeningProcess = selectedRows.every(row => CandidateStatusEnum.PROCESSING === row.status && (!row.changeEmpTypeFlg && !row.staffMovementFlg));
    const isEmployeeProcess = selectedRows.every(row => CandidateStatusEnum.PROCESSING === row.status && (row.changeEmpTypeFlg || row.staffMovementFlg));
    const isEmployeeChangeEmpType = selectedRows.every(row => CandidateStatusEnum.EMPLOYEE === row.status && row.changeEmpTypeFlg);
    const isEmployeeStaffMovement = selectedRows.every(row => CandidateStatusEnum.EMPLOYEE === row.status && row.staffMovementFlg);
    if (isOpening || isOpeningProcess) {
      return 'OPENING';
    } else if (isEmployeeProcess) {
      return 'EMPLOYEE_PROCESS';
    } else if (isEmployeeChangeEmpType) {
      return 'EMPLOYEE_CHANGE_EMP_TYPE';
    } else if (isEmployeeStaffMovement) {
      return 'EMPLOYEE_STAFF_MOVEMENT';
    }
    /*
      OPENING: OPENING or (PROCESSING + changeEmpTypeFlg 0 && staffMovementFlg 0)
        + internalQuantity === 0
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 1
      EMPLOYEE_PROCESS: PROCESSING + changeEmpTypeFlg 1 || staffMovementFlg 1
        + internalQuantity === 0
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 1
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 0
      EMPLOYEE_CHANGE_EMP_TYPE: EMPLOYEE + changeEmpTypeFlg 1
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 1
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 0
      EMPLOYEE_STAFF_MOVEMENT: EMPLOYEE + staffMovementFlg 1
        + internalQuantity === 0
        + internalQuantity > 0 && supportChangeEmpTypeFlg === 0
    */
  }

  static addItemIfNotExists(itemList: any[], newItem: any): void {
    const exists = itemList.find(item => item.id === newItem.id);
    if (!exists) {
      itemList.push(newItem);
    }
  }

  static formatDateFromTime(date) {
    // Ensure the input is a valid date string
    const d = new Date(date);

    // Extract the year, month, and day
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(d.getUTCDate()).padStart(2, '0');

    // Return formatted date as "YYYY-MM-DD"
    return `${year}-${month}-${day}`;
  }

  /**
   * @deprecated Legacy sanitization method - kept for comparison only
   * Use sanitizeHtml() with DOMPurify instead for better security
   * 
   * Old implementation using simple string replacement
   * WARNING: This approach is vulnerable to XSS attacks and should NOT be used
   */
  static sanitizeHtml_backup(content: string): string {
    if (!content) return '';
    return content
      .trim()
      .replaceAll('<script', '')
      .replaceAll('<script>', '')
      .replaceAll('onerror', '')
      .replaceAll('onclick', '')
      .replaceAll('onload', '')
      .replaceAll('alert(', '')
      .replaceAll('console', '')
      .replaceAll('onchange', '')
      .replaceAll('onmouseover', '')
      .replaceAll('onmouseout', '')
      .replaceAll('onkeydown', '')
      .replaceAll('onkeypress', '')
      .replaceAll('onkeyup', '')
      .replaceAll('javascript', '')
      .replaceAll('eval', '')
      .replaceAll('jquery', '')
      .replaceAll('$', '')
      .replaceAll('atob', '')
      .replaceAll('btob', '');
  }

  /**
   * Sanitizes HTML content using DOMPurify to prevent XSS attacks
   * @param content - HTML string to sanitize
   * @param config - Optional DOMPurify configuration
   * @returns Sanitized HTML string
   */
  static sanitizeHtml(content: string, config?: DOMPurify.Config): string {
    if (!content) return '';

    // Security: Prevent type confusion attacks (array, object bypass)
    if (typeof content !== 'string') {
      console.error('sanitizeHtml: Invalid input type, expected string but got', typeof content);
      return '';
    }

    // Default DOMPurify configuration - aligned with ngx-quill provideQuillConfig
    const defaultConfig: DOMPurify.Config = {
      ALLOWED_TAGS: [
        // Text formatting
        'p', 'br', 'strong', 'em', 'u', 's', 'span', 'div',
        // Headings (h1-h6 from Quill header dropdown)
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        // Lists (ordered/bullet from Quill)
        'ul', 'ol', 'li',
        // Quotes and code (blockquote, code-block from Quill)
        'blockquote', 'code', 'pre',
        // Links and media (link, image, video from Quill)
        'a', 'img', 'video', 'source',
        // Tables (if needed for pasted content)
        'table', 'thead', 'tbody', 'tr', 'th', 'td',
        // Script formatting (sub/super from Quill)
        'sub', 'sup', 'hr'
      ],
      ALLOWED_ATTR: [
        // Links
        'href', 'target', 'rel',
        // Media
        'src', 'alt', 'title', 'width', 'height', 'controls', 'type',
        // Formatting (Quill uses inline styles for color, background, size, font, align)
        'class', 'style',
        // List attributes
        'start', 'reversed',
        // Table attributes
        'colspan', 'rowspan',
        'border', 'cellspacing', 'cellpadding',
        'align', 'role', 'data-list', 'contenteditable'
      ],
      ALLOW_DATA_ATTR: true, // Quill may use data attributes for formatting
      FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
      FORBID_ATTR: [
        'onerror', 'onclick', 'onload', 'onchange', 'onmouseover',
        'onmouseout', 'onkeydown', 'onkeypress', 'onkeyup', 'onfocus', 'onblur',
        'onsubmit', 'ondblclick', 'oncontextmenu'
      ],
      ...config
    };

    return DOMPurify.sanitize(content.trim(), defaultConfig);
  }

  static editorChange(value: any, control: string, componentForm: FormGroup): void {
    if (value && typeof (value) === "object") {
      value = toHTML(value);
    }
    if (value && value.startsWith('<p>')) {
      let temp = value.replace('<p>', '').replace('</p>', '').trim();
      if (!temp) {
        value = null;
      }
    }
    const sanitizedValue = UtilCommon.sanitizeHtml(value);
    componentForm?.get(control)?.setValue(sanitizedValue);
  }

  static escapeHtml(input: any): string {
    if (input == null) return '';
    // Sanitize first, then escape
    const sanitized = UtilCommon.sanitizeHtml(String(input));
    return sanitized
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;');
  }

  static unescapeHtml(input: string): string {
    if (!input) return '';
    return input
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&#x2F;/g, '/');
  }

  /**
   * Validates if a PDF source URL is from trusted domains
   * @param url - The PDF URL to validate
   * @returns true if URL is from trusted source, false otherwise
   */
  static isTrustedPdfSource(url: string): boolean {
    return true; // Temporarily allow all URLs
    if (!url) return false;

    try {
      // Allow data URLs (base64 embedded PDFs)
      if (url.startsWith('data:application/pdf')) {
        return true;
      }

      // Allow blob URLs (client-side generated)
      if (url.startsWith('blob:')) {
        return true;
      }

      const urlObj = new URL(url);

      // Trusted domains list - adjust based on your requirements
      const trustedDomains = [
        'hrm-api-dev.a4b.vn',
        'hrm-api-staging.a4b.vn',
        'hrm-api.a4b.vn',
        'hrm-dev.a4b.vn',
        'hrm-staging.a4b.vn',
        'hrm.a4b.vn',
        'hunt-dev.a4b.vn',
        'athenahunt.athenafs.io',
        'ats-staging.vng.vn',
        // AWS S3 buckets
        's3.ap-southeast-1.amazonaws.com',
        's3-ap-southeast-1.amazonaws.com'
      ];

      // Check if hostname matches any trusted domain
      const hostname = urlObj.hostname.toLowerCase();
      return trustedDomains.some(domain =>
        hostname === domain || hostname.endsWith('.' + domain)
      );
    } catch (error) {
      // Invalid URL format
      console.error('Invalid PDF URL:', error);
      return false;
    }
  }

  /**
   * Sanitizes and validates PDF URL before loading
   * @param url - The PDF URL to sanitize
   * @returns Sanitized URL or null if invalid
   */
  static sanitizePdfUrl(url: string | any): string | null {
    if (!url) return null;

    // Security: Prevent type confusion attacks (array, object bypass)
    // Example: ['javascript:alert(1)'] or {toString: () => 'javascript:alert(1)'}
    if (typeof url !== 'string') {
      console.error('sanitizePdfUrl: Invalid input type, expected string but got', typeof url, url);
      return null;
    }

    // Allow data:application/pdf;base64 and data:application/octet-stream;base64 for embedded PDFs
    const urlLower = url.toLowerCase().trim();
    const DATA_PDF_PREFIX = 'data:application/pdf;base64,';
    const DATA_OCTET_PREFIX = 'data:application/octet-stream;base64,';

    // Helper to validate base64-only characters
    const base64Regex = /^[A-Za-z0-9+/=]+$/;

    if (urlLower.startsWith(DATA_PDF_PREFIX)) {
      const base64Part = url.substring(DATA_PDF_PREFIX.length);
      if (!base64Regex.test(base64Part)) {
        console.error('sanitizePdfUrl: Invalid base64 format in data URL');
        return null;
      }
      return url; // Valid PDF data URL
    }

    // Accept octet-stream only when the decoded bytes indicate a PDF ("%PDF")
    if (urlLower.startsWith(DATA_OCTET_PREFIX)) {
      const base64Part = url.substring(DATA_OCTET_PREFIX.length);
      if (!base64Regex.test(base64Part)) {
        console.error('sanitizePdfUrl: Invalid base64 format in data URL (octet-stream)');
        return null;
      }

      try {
        // Decode only a small prefix to avoid decoding huge payloads
        const sampleBase64 = base64Part.substring(0, 64);
        const buf = Buffer.from(sampleBase64, 'base64');
        const signature = buf.slice(0, 4).toString('utf8');
        if (signature !== '%PDF') {
          console.error('sanitizePdfUrl: octet-stream data does not contain PDF signature');
          return null;
        }
        return url; // Looks like a PDF embedded as octet-stream
      } catch (err) {
        console.error('sanitizePdfUrl: Error decoding base64 octet-stream sample', err);
        return null;
      }
    }

    // Security: Validate URL protocol BEFORE any processing
    const dangerousProtocols = [
      'javascript:',
      'data:', // Block other data: types (only allow data:application/pdf;base64)
      'vbscript:',
      'file:',
      'about:',
      'blob:'
    ];

    for (const protocol of dangerousProtocols) {
      if (urlLower.startsWith(protocol)) {
        console.error('sanitizePdfUrl: Dangerous protocol detected', protocol, url);
        return null;
      }
    }

    // For URLs, we DON'T use DOMPurify (it converts & to &amp;, breaks query params)
    // Instead, validate using URL constructor and trusted domain check
    const trimmedUrl = url.trim();

    // Validate URL format and protocol
    try {
      const urlObj = new URL(trimmedUrl);

      // Only allow https and http protocols
      if (urlObj.protocol !== 'https:' && urlObj.protocol !== 'http:') {
        console.error('sanitizePdfUrl: Invalid protocol', urlObj.protocol);
        return null;
      }

      // Validate against trusted sources
      if (!this.isTrustedPdfSource(trimmedUrl)) {
        console.warn('Untrusted PDF source blocked:', trimmedUrl);
        return null;
      }

      return trimmedUrl; // Return original URL (preserves & not &amp;)

    } catch (error) {
      console.error('sanitizePdfUrl: Invalid URL format', error);
      return null;
    }
  }

  /**
   * Safely opens URL in new window/tab
   * @param url - URL to open
   * @param target - Window target (_blank, _self, etc.)
   * @returns Window reference or null if blocked
   * 
   * @example
   * // Component usage:
   * openLink(url: string) {
   *   UtilCommon.windowOpenUrl(url); // Automatically sanitized
   * }
   */
  static windowOpenUrl(url: string, target: string = '_blank'): Window | null {
    // Sanitize and validate URL
    const sanitizedUrl = UtilCommon.sanitizePdfUrl(url);

    if (!sanitizedUrl) {
      console.error('windowOpenUrl: URL blocked by sanitization', url);
      return null;
    }

    try {
      // Open in new window with security features
      const windowRef = window.open(sanitizedUrl, target, 'noopener,noreferrer');

      // Additional security: Clear opener reference
      if (windowRef && target === '_blank') {
        windowRef.opener = null;
      }

      return windowRef;
    } catch (error) {
      console.error('windowOpenUrl: Failed to open URL', error);
      return null;
    }
  }

  /**
   * Safely navigates to URL in current window
   * @param url - URL to navigate to
   * @returns true if navigation initiated, false if blocked
   * 
   * @example
   * navigateToUrl(url: string) {
   *   if (!UtilCommon.navigateToUrl(url)) {
   *     alert('Invalid URL');
   *   }
   * }
   */
  static navigateToUrl(url: string): boolean {
    const sanitizedUrl = UtilCommon.sanitizePdfUrl(url);

    if (!sanitizedUrl) {
      console.error('navigateToUrl: URL blocked', url);
      return false;
    }

    try {
      window.location.href = sanitizedUrl;
      return true;
    } catch (error) {
      console.error('navigateToUrl: Failed to navigate', error);
      return false;
    }
  }
}
